// from incluso, to escluso

export default [
  {
    "code": "Promo Tè",
    "percent": 20,
    "categories": ["EC81001"],
    "minProducts": 3,
    "from": "2025-03-26",
    "to": "2025-04-14"
  },
  {
    "code": "Promo Primavera Cosmetica",
    "percent": 15,
    "categories": ["EC62000"],
    "minProducts": 2,
    "from": "2025-05-14",
    "to": "2025-06-03"
  },
]

